import loadable from '@loadable/component';

export const CartPillContainerLoadable = loadable(
  () => import('./CartPillContainer'),
  { resolveComponent: (module) => module.CartPillContainer },
);
